import {TkFile} from '../../interfaces/core/tk-file';
import {Photo} from '@capacitor/camera';

export class TkFileFactory {

  /**
   *
   */
  public static new(): TkFile {
    return new class implements TkFile {
      id: number = null;
      filepath: string = null;
      webviewPath: string = null;
      format: string = null;
      name: string = null;
      mimeType: string = null;
      loaded: boolean = false;
    };
  }

  /**
   *
   * @param photo
   */
  public static fromPhoto(photo: Photo): TkFile {
    return new class implements TkFile {
      id: number = null;
      filepath: string = photo.path;
      webviewPath: string = photo.webPath;
      format: string = photo.format;
      name: string = null;
      mimeType: string = null;
      loaded: boolean = true;
    }
  }

  /**
   *
   * @param file
   */
  public static fromObject(file: any): TkFile {
    return {
      ...this.new(),
      id: file.id ?? null,
      filepath: file.filepath ?? null,
      webviewPath: file.webview_path ?? file.webviewPath ?? null,
      format: file.extension ?? file.format ?? null,
      name: file.name ?? file.file_name ?? null,
      mimeType: file.mime_type ?? file.mimeType ?? null,
      loaded: file.loaded ?? false,
    };
  }

}
